import { render, staticRenderFns } from "./ContentList.vue?vue&type=template&id=1a9a8531&"
import script from "./ContentList.vue?vue&type=script&lang=ts&"
export * from "./ContentList.vue?vue&type=script&lang=ts&"
import style0 from "./ContentList.vue?vue&type=style&index=0&id=1a9a8531&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports